import React, { useState, useEffect } from "react";
import JsCodeEditor from "../../../components/JsCodeEditor";
import CssCodeEditor from "../../../components/CssCodeEditor";
import ColorPicker from "../../../components/ColorPicker";
import { toast } from 'react-toastify';

const StyleTab = ({ handleLayoutChange, selectedLayout, updatePayPalButtonTabData, payPalButtonTabData }) => {
    const [activeSettingElementsTab, setActiveSettingElementsTab] = useState("main");
    const [buttonWidth, setButtonWidth] = useState(payPalButtonTabData.button_width);
    const [buttonSize, setButtonSize] = useState(payPalButtonTabData.button_size);
    const [activeShapeType, setActiveShapeType] = useState(payPalButtonTabData.button_shape_type);
    const [buttonBorderSize, setButtonBorderSize] = useState(payPalButtonTabData.button_border_size);
    const [buttonColor, setButtonColor] = useState(payPalButtonTabData.button_color);
    const [buttonTextColor, setButtonTextColor] = useState(payPalButtonTabData.button_text_color);
    const [buttonBorderColor, setButtonBorderColor] = useState(payPalButtonTabData.button_border_color);
    const [selectedPaypalColorType, setSelectedPaypalColorType] = useState(payPalButtonTabData.paypal_logo_color);
    const [showPaypalColorTypeDropdown, setShowPaypalColorTypeDropdown] = useState(false);
    const [jsTabCustomJs, setJsTabCustomJs] = useState(payPalButtonTabData.custom_js);
    const [styleTabCustomCss, setStyleTabCustomCss] = useState(payPalButtonTabData.custom_css);

    //Handlers Button Width Change
    const handleButtonWidthChange = (e) => {
        const value = e.target.value;
        setButtonWidth(value);
        updatePayPalButtonTabData("button_width", value); 
    };

    // Handlers Button Size Change
    const handleButtonSizeChange = (e) => {
        const value = e.target.value;
        setButtonSize(value);
        updatePayPalButtonTabData("button_size", value);
    };

    // Handle Shape Type change
    const handleActiveShapeTypeChange = (event) => {
        setActiveShapeType(event.target.value);
        updatePayPalButtonTabData("button_shape_type", event.target.value);
    };

    // Handlers Button Border Size Change
    const handleButtonBorderSizeChange = (e) => {
        const value = e.target.value;
        setButtonBorderSize(value);
        updatePayPalButtonTabData("button_border_size", value);
    };

    // Handlers Button Color Change
    const handleButtonColorChange = (color) => {
        setButtonColor(color.hex);
        updatePayPalButtonTabData("button_color", color.hex);
    };

    // Handlers Button Text Color Change
    const handleButtonTextColorChange = (color) => {
        setButtonTextColor(color.hex);
        updatePayPalButtonTabData("button_text_color", color.hex);
    };

    // Handlers Button Border Color Change
    const handleButtonBorderColorChange = (color) => {
        setButtonBorderColor(color.hex);
        updatePayPalButtonTabData("button_border_color", color.hex);
    };

    //Handle Paypal Color Type Dropdown Change
    const togglePaypalColorTypeDropdown = () => {
        setShowPaypalColorTypeDropdown(!showPaypalColorTypeDropdown);
    };
    //Handle Paypal Color Type Change
    const handlePaypalColorTypeSelect = (type) => {
        setSelectedPaypalColorType(type);
        updatePayPalButtonTabData("paypal_logo_color", type); 
        setShowPaypalColorTypeDropdown(false); 
    };

    // Handlers Custom Js Change
    const handleCustomJsCodeChange = (code) => {
        setJsTabCustomJs(code);
        updatePayPalButtonTabData("custom_js", code);
    };

    // Function to run the JS code when Validate is clicked
    const handleValidateClick = () => {
        const existingScript = document.getElementById("custom-js");
        if (existingScript) {
            existingScript.remove();
        }
    
        if (jsTabCustomJs && jsTabCustomJs.trim() !== "") {
            const script = document.createElement("script");
            script.id = "custom-js";
            script.type = "text/javascript";
            script.innerHTML = jsTabCustomJs;
    
            document.body.appendChild(script);
    
            toast.success("Custom JS applied successfully");
        } else {
            toast.error("No JS code to apply");
        }
    };

    // Handlers Custom CSS Change
    const handleCustomcssCodeChange = (code) => {
        setStyleTabCustomCss(code);
        updatePayPalButtonTabData("custom_css", code);
    };

    //Inject CSS into the page whenever it changes
    useEffect(() => {
        let styleTag = document.getElementById("custom-style");

        if (!styleTag) {
            styleTag = document.createElement("style");
            styleTag.id = "custom-style";
            document.head.appendChild(styleTag);
        }

        styleTag.innerHTML = styleTabCustomCss || "";
    }, [styleTabCustomCss]);

    return (
        <div className="side-baar-layout-tab">
            {activeSettingElementsTab === "main" && (
                <>
                    <span>Style</span>
                    <div className="side-baar-box-header">
                        <div className="box-header-row bubble-text">
                            <label>Width (px, %, auto)</label>
                            <input name="width" value={buttonWidth} onChange={handleButtonWidthChange} placeholder="Width..." type="text" />
                        </div>
                        <div className="box-header-row">
                            <span>Button Size</span>
                            <em>{buttonSize}</em>
                            <div className="slider-container">
                                <input type="range" min="10" max="100" value={buttonSize} onChange={handleButtonSizeChange}/>
                            </div>
                        </div>
                        <div className="box-header-row">
                            <p>Button Shape</p>
                            <div className="left-cnater-right-button">
                                <label className="card-radio-btn">
                                    <input type="radio" name="shape_type" className="card-input-element d-none" value="normal-shape" onChange={handleActiveShapeTypeChange} checked={activeShapeType === "normal-shape"} />
                                    <div className="card card-body">
                                        <div className="content_sub">
                                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
                                            <path  fill="#cfcfcf"  fill-rule="evenodd" d="M15.833 4.167V17.5h-1.568V5.735H2.5V4.167z"></path>
                                            </svg>
                                        </div>
                                    </div>
                                </label>
                                <label className="card-radio-btn">
                                    <input type="radio" name="shape_type" className="card-input-element d-none" value="medium-shape" onChange={handleActiveShapeTypeChange} checked={activeShapeType === "medium-shape"} />
                                    <div className="card card-body">
                                        <div className="content_sub">
                                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path fill="#cfcfcf" fill-rule="evenodd" d="M9.82 4.167a6.013 6.013 0 0 1 6.01 5.839l.003.174v7.32h-1.568v-7.32a4.445 4.445 0 0 0-4.289-4.442l-.156-.003H2.5V4.167h7.32Z"></path></svg>
                                        </div>
                                    </div>
                                </label>
                                <label className="card-radio-btn">
                                    <input type="radio" name="shape_type" className="card-input-element d-none" value="large-shape" onChange={handleActiveShapeTypeChange} checked={activeShapeType === "large-shape"} />
                                    <div className="card card-body">
                                        <div className="content_sub">
                                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path  fill="#cfcfcf" fill-rule="evenodd" d="M3.284 4.167c6.856 0 12.428 5.498 12.547 12.326l.002.223v.784h-1.568v-.784c0-5.994-4.803-10.866-10.77-10.979l-.21-.002H2.5V4.167h.784Z"></path></svg>
                                        </div>
                                    </div>
                                </label>
                            </div>
                        </div>
                        <div className="box-header-row">
                            <span>Button Border Size</span>
                            <em>{buttonBorderSize}px</em>
                            <div className="slider-container">
                                <input type="range" min="0" max="10" value={buttonBorderSize} onChange={handleButtonBorderSizeChange}/>
                            </div>
                        </div>
                        <div className="box-header-row">
                            <span>Button Color</span>
                            <div className="color-pikr-box">
                                <ColorPicker color={buttonColor} setColor={setButtonColor} onChangeComplete={handleButtonColorChange}/>
                            </div>
                        </div>
                        <div className="box-header-row">
                            <span>Button Text Color</span>
                            <div className="color-pikr-box">
                                <ColorPicker color={buttonTextColor} setColor={setButtonTextColor} onChangeComplete={handleButtonTextColorChange}/>
                            </div>
                        </div>
                        <div className="box-header-row">
                            <span>Button Border Color</span>
                            <div className="color-pikr-box">
                                <ColorPicker color={buttonBorderColor} setColor={setButtonBorderColor} onChangeComplete={handleButtonBorderColorChange}/>
                            </div>
                        </div>
                        <div className="box-header-row d-flex justify-content-between align-items-center">
                            <span>Paypal Logo</span>
                            <em onClick={togglePaypalColorTypeDropdown}>{selectedPaypalColorType}</em>
                            {showPaypalColorTypeDropdown && (
                                <ul className="dropdown-list h-auto">
                                    {['Original', 'White'].map((type) => (
                                        <li key={type} onClick={() => handlePaypalColorTypeSelect(type)}>
                                            {type}
                                        </li>
                                    ))}
                                </ul>
                            )}
                        </div>
                    </div>
                    <div className="customize-elements-list">
                        <ul>
                            <li>
                                <button onClick={() => setActiveSettingElementsTab("custom_css")}>Custom Css <i className="fa fa-angle-right" aria-hidden="true"></i></button>
                            </li>
                            <li><button onClick={() => setActiveSettingElementsTab("custome_js")}>Custom JS <i className="fa fa-angle-right" aria-hidden="true"></i></button></li>
                        </ul>
                    </div>
                </>
            )}

            {activeSettingElementsTab === "custom_css" && (
                <>
                    <div className="inner-box-layout">
                        <span><button onClick={() => setActiveSettingElementsTab("main")}><i className="fa fa-angle-left" aria-hidden="true"></i>Back</button> Custom CSS</span>
                        <div className="css-text height-text">
                            <CssCodeEditor code={styleTabCustomCss} setCode={setStyleTabCustomCss} onChangeComplete={handleCustomcssCodeChange}/>
                        </div>
                    </div>
                </>
            )} 

            {activeSettingElementsTab === "custome_js" && (
                <>
                    <div className="inner-box-layout">
                        <span>  <button onClick={() => setActiveSettingElementsTab("main")}><i className="fa fa-angle-left" aria-hidden="true"></i>Back</button> Custom JS Editor</span>
                        <div className="css-text">
                            <JsCodeEditor code={jsTabCustomJs} setCode={setJsTabCustomJs} onChangeComplete={handleCustomJsCodeChange}/>
                            <button className="validate" onClick={handleValidateClick}>Validate</button>
                        </div>
                        <p>Tip: It is recommended to use the CSS classes with the “es” prefix, as these are specially designed for stable customization. Please note, while these classes are intended to be more static, we cannot guarantee that they will remain unchanged in future updates.</p>
                    </div>
                </>
            )}
        </div>
    );
};

export default StyleTab;